import { useParams } from 'react-router-dom';

import { useGetSupervisorProjectByIdQuery } from './api/supervisorProjectsApiSlice';

export const useSupervisorProjectDetails = () => {
  const { projectId } = useParams();

  const {
    data: projectDetailsData,
    isLoading: isProjectDetailsLoading,
    isFetching: isProjectDetailsFetching,
  } = useGetSupervisorProjectByIdQuery(
    { projectId: projectId as string },
    { skip: !projectId || projectId === '' }
  );

  return {
    projectId,
    projectName: projectDetailsData?.data?.basics?.projectName ?? '',
    createdOn: projectDetailsData?.data?.createdAt ?? '',
    startedOn: projectDetailsData?.data?.startDate ?? '',
    completedOn: projectDetailsData?.data?.completedDate ?? '',
    isProjectDetailsLoading: isProjectDetailsLoading || isProjectDetailsFetching,
  };
};
